/**
 * @fileoverview Sectors attended and years of experience in each selected sector.
 */

import styles from "./Certifications.module.css";
import SectorCheckboxRows from "./SectorCheckboxRows";
import SectorExperienceRows from "./SectorExperienceRows";

const SectorExperienceSection = ({ section, isTablet }) => {
  const {
    t,
    availableSectors,
    sectors,
    yearsOptions,
    handleSectorCheckboxChange,
    handleSectorExperienceChange,
  } = section;

  return (
    <>
      <div className={styles.sectionHeader}>
        <span className={styles.inputLabel}>
          {t("components.certifications.sectorsAttendedLabel")}
        </span>
      </div>
      <div className={styles.checkboxContainer}>
        <SectorCheckboxRows
          availableSectors={availableSectors}
          sectors={sectors}
          onSectorCheckboxChange={handleSectorCheckboxChange}
        />
      </div>

      {sectors.length > 0 && (
        <>
          <div className={styles.sectionHeader}>
            <span className={styles.inputLabel}>
              {t("components.certifications.yearsOfExperienceInTheSectorLabel")}
            </span>
          </div>
          <div
            className={`${styles.checkboxContainer} ${styles.sectorsSpacing}`}
          >
            <SectorExperienceRows
              sectors={sectors}
              isTablet={isTablet}
              yearsOptions={yearsOptions}
              onExperienceChange={handleSectorExperienceChange}
              t={t}
            />
          </div>
          <p className={styles.notVisibleFieldMessage}>
            *
            {t(
              "components.certifications.notVisibleFieldsForOtherMembersLabel",
            )}
          </p>
        </>
      )}
    </>
  );
};

export default SectorExperienceSection;
